// Modal de registrar Perda (Fase 5, ADR-0022): tira de vez do Backlog a Peça
// que não volta mais. Mira uma linha de saldo concreta — a quantidade nunca
// passa do que aquela linha tem.

import { codigoSublote, MOTIVO_BACKLOG_INICIAL, type SaldoLinha } from "../../domain/backlog.ts";
import { hojeISO } from "../../domain/datas.ts";
import type { Store } from "../store.ts";
import { el, openModal, botao } from "../ui.ts";
import { criarAcaoComando } from "./_acao.ts";
import { campo, campoObrigatorio, inputData } from "./_cadastro.ts";
import { listaSelect } from "./_lista-select.ts";

export function abrirPerda(
  store: Store,
  linha: SaldoLinha,
  aoSalvar: () => void,
): void {
  const snap = store.get();
  const cliente = snap.clientes.find((c) => c.id === linha.clienteId);
  const tipo = snap.tiposPeca.find((t) => t.id === linha.tipoId);
  const origem = linha.origemLoteId
    ? snap.lotes.find((l) => l.id === linha.origemLoteId)
    : null;

  openModal("Registrar Perda", (fechar) => {
    const erro = el("p", { class: "form-erro", role: "alert" });

    const quantidade = el("input", {
      type: "number",
      min: "1",
      max: String(linha.quantidade),
      step: "1",
      value: "1",
    }) as HTMLInputElement;

    const motivo = listaSelect(store, "motivosDivergencia", "");
    const data = inputData(hojeISO());
    // o domínio recusa data futura ou anterior à entrada da peça (ADR-0028)
    data.max = hojeISO();

    const cancelar = botao("secundario", {}, "Cancelar");
    cancelar.addEventListener("click", fechar);
    const ok = botao("primario", { type: "submit" }, "Registrar Perda");

    const form = el(
      "form",
      { class: "form-modal" },
      el(
        "p",
        { class: "muted" },
        `${cliente?.nome ?? "—"} · ${tipo?.nome ?? "—"} · ${linha.motivo} · `,
        origem ? codigoSublote(origem) : MOTIVO_BACKLOG_INICIAL,
      ),
      el(
        "p",
        { class: "muted" },
        "No Backlog nesta linha: ",
        el("b", {}, String(linha.quantidade)),
        " peça(s).",
      ),
      el(
        "div",
        { class: "grid-2" },
        campo("Quantidade perdida", quantidade),
        campo("Data", data),
      ),
      campoObrigatorio("Motivo", motivo.element),
      el(
        "p",
        { class: "muted" },
        "A peça sai do Backlog e não volta mais. Dá para desfazer excluindo a perda.",
      ),
      erro,
      el("div", { class: "modal-actions" }, cancelar, ok),
    );

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      erro.textContent = "";
      ok.disabled = true;
      void criarAcaoComando(store, erro)(
        {
          agregado: "perda",
          cmd: {
            tipo: "registrar",
            dados: {
              clienteId: linha.clienteId,
              tipoId: linha.tipoId,
              origemLoteId: linha.origemLoteId,
              motivoOrigem: linha.motivo,
              motivo: motivo.value(),
              quantidade: Number(quantidade.value) || 0,
              data: data.value,
            },
          },
        },
        "Perda registrada.",
        () => {
          aoSalvar();
          fechar();
        },
      ).finally(() => {
        ok.disabled = false;
      });
    });
    return form;
  });
}
